export default __webpack_public_path__ + "static/media/interreg-mitomed-transparente.206e6a5e.png";